<script lang="ts" setup>
defineProps({
  slice: {
    type: Object,
    required: true,
  },
  index: {
    type: Number,
    required: true,
  },
  slices: {
    type: Array,
    required: true,
  },
})
</script>

<template>
  <StrapiSlice
    class="ct-media-feed"
    :slice="slice"
    :index="index"
    variant="horizontal"
  >
    <UiCarousel
      v-if="slice?.FeedDisplay?.Display === 'Slider'"
      class="ct-media-feed__carousel"
      :class="{
        /* Non responsive & non modern settings */
        'ui-carousel--center': false,
        'ui-carousel--free-scroll': true,
        'ui-carousel--navigation': true,
        'ui-carousel--pagination': false,
        'ui-carousel--progress': false,
      }"
    >
      <template
        v-for="(data, i) in slice?.Files"
        #[`slide-${i}`]
        :key="data"
      >
        <StrapiMedia
          class="ct-media-feed__media"
          :media="data"
          :lazy="index > 0"
          :banner-count="slice?.Files?.length"
          :full-width="slice?.Settings?.SliceWidth?.toLowerCase() === 'full_width'"
        />
      </template>
    </UiCarousel>

    <ul
      v-else
      class="ct-media-feed__grid"
      :style="`--columns: ${slice?.Files?.length};`"
    >
      <li
        v-for="data in slice.Files"
        :key="data"
        class="ct-media-feed__grid-item"
      >
        <StrapiMedia
          :class="['ct-media-feed__media', { 'media--hero': slice?.Files?.length === 1 && slice?.Settings?.SliceWidth?.toLowerCase() === 'full_width' }]"
          :media="data"
          :lazy="index > 0"
          :banner-count="slice?.Files?.length"
          :full-width="slice?.Settings?.SliceWidth?.toLowerCase() === 'full_width'"
        />
      </li>
    </ul>
  </StrapiSlice>
</template>

<style>
@import url("~layers/components/Slices/MediaFeed.css");
</style>
